
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "BigPhoneBlock",

  computed: {
    phoneNumber: function () {
      return this.$store.state?.appState?.vars?.['Телефон']
    }
  },

  methods: {
    openPopUpCall: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          activeTab: "big"
        }
      })
    }
  }
})
